export default "__VITE_ASSET__Cnw78EXg__"